<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-ios-cart"></i>
        <div class="mg-l-20 mg-r-25">
          <h4>
            {{ $t("router.原料订单管理") }}
            {{ isHistoryData ? `(${$t("rm.历史采购单")})` : "" }}
          </h4>
        </div>
      </div>
      <div class="tx-right d-flex align-items-center">
        <a
          class="tx-info mg-r-15"
          href="javascript:;"
          @click="accordionProducts"
          >{{ isAccordion ? $t("order.展开商品") : $t("order.折叠商品") }}</a
        >
        <!-- <a
          v-if="!isHistoryData"
          href="javascript:;"
          class="btn btn-primary d-inline-block wd180 mg-r-15"
          data-toggle="dropdown"
        >
          <div class="d-flex align-items-center justify-content-between">
            <span class="mg-r-10 tx-13 tx-medium">{{
              $t("order.批处理")
            }}</span>
            <i class="fa fa-angle-down mg-l-10"></i>
          </div>
        </a> -->
        <div
          class="dropdown-menu pd-10"
          id="batDropdown"
          style="max-width: 11rem"
        >
          <nav class="nav nav-style-1 flex-column" id="upload_wrap">
            <a
              href="javascript:;"
              class="nav-link pd-x-0 tx-left d-flex align-items-center"
              >{{ $t("rm.批量审核") }}</a
            >
            <a
              href="javascript:;"
              class="nav-link pd-x-0 tx-left d-flex align-items-center"
              >{{ $t("rm.批量作废") }}</a
            >
            <a
              href="javascript:;"
              class="nav-link pd-x-0 tx-left d-flex align-items-center"
              >{{ $t("rm.批量标记完成") }}</a
            >
            <a
              href="javascript:;"
              class="nav-link pd-x-0 tx-left d-flex align-items-center"
              >{{ $t("rm.批量标记发货") }}</a
            >
          </nav>
        </div>
        <a
          v-if="isSysRights('SupplierPurchaseOrder.import')"
          href="javascript:;"
          class="btn btn-primary mg-r-15"
          @click="importOrder"
          >{{ $t("rm.导入采购单") }}</a
        >
        <a
          v-if="isSysRights('SupplierPurchaseOrder.export')"
          href="javascript:;"
          class="btn"
          :class="
            check_arr.length > 0 ? 'btn-primary' : 'btn-outline-secondary'
          "
          @click="exportOrder"
          >{{ $t("financial.导出采购单") }}</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-end justify-content-start pd-x-20 pd-sm-x-30"
    >
      <!-- <div class="dropdown mg-r-15 ordertime-select">
        <a href="" class="tx-gray-800 d-inline-block" data-toggle="dropdown">
          <span class="mg-r-5">{{
            isHistoryData ? $t("rm.历史采购单") : $t("rm.近三个月采购单")
          }}</span>
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </a>
        <div class="dropdown-menu">
          <nav class="nav">
            <router-link :to="'/'" class="nav-link">
              {{ $t("rm.近三个月采购单") }}
            </router-link>
            <router-link
              :to="'/RM-order-history/' + selectedTime"
              class="nav-link"
            >
              {{ $t("rm.历史采购单") }}
            </router-link>
          </nav>
        </div>
      </div> -->
      <div v-show="isHistoryData" class="dropdown select-month mg-r-15">
        <a class="selected" href="javascripot:;" data-toggle="dropdown">
          {{ selectedTime | timeCN }}
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </a>
        <div class="dropdown-menu select-list">
          <ul
            :style="{
              width: Math.ceil((selectTimeLi || '').length / 5) * 5 + 'rem',
              transform: 'translateX(-' + timeIndex * 10 + 'rem)',
            }"
          >
            <li
              v-for="month in selectTimeLi"
              :key="month.time"
              :class="{ active: month.time == selectedTime }"
            >
              <router-link :to="'/purchase-order-history/' + month.time">{{
                month.time
              }}</router-link>
            </li>
          </ul>
        </div>
        <a
          v-show="timeIndex > 0"
          class="left-arr"
          href="javascript:;"
          data-stopPropagation="true"
        >
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </a>
        <a
          v-show="timeIndex < Math.floor((selectTimeLi || '').length / 10)"
          class="right-arr"
          href="javascript:;"
          data-stopPropagation="true"
        >
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-if="status_id"
          @click="clearKey('statusId')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.采购单状态：") }}
          <span class="mg-r-10">{{ activeGroupName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="key_code"
          @click="clearKey('code')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ codeText }}
          <span class="mg-r-10">{{ key_code }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="key_name"
          @click="clearKey('key_id')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.供应商：") }}
          <span class="mg-r-10">{{ key_name }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="key_timeCreatedFrom || key_timeCreatedTo"
          @click="clearKey('time')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ dateText }}
          <span class="mg-r-10"
            >{{ key_timeCreatedFrom }}{{ $t("distributor.至")
            }}{{ key_timeCreatedTo }}</span
          >
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "isHistoryData", // 是否是历史数据
    "isAccordion",
    "check_arr",
    "selectTimeLi", // 选择月份列表
    "selectedTime", // 已选择的时间
    "status_id",
    "activeGroupName",
    "key_codeType",
    "key_code",
    "key_name",
    "key_timeType",
    "key_timeCreatedFrom",
    "key_timeCreatedTo",
    "batchBool"
  ],
  data() {
    return {
      timeIndex: 0,
    };
  },
  computed: {
    codeText() {
      if (this.key_codeType == 2) {
        return this.$t("distributor.物流单号：");
      } else if (this.key_codeType == 3) {
        return "SKU：";
      } else if (this.key_codeType == 4) {
        return "SPU：";
      } else {
        return this.$t("order.采购单：");
      }
    },
    dateText() {
      if (this.key_timeType == 2) {
        return this.$t("rm.发货日期：");
      } else if (this.key_timeType == 3) {
        return this.$t("distributor.入库日期：");
      } else {
        return this.$t("distributor.采购日期：");
      }
    },
  },
  filters: {
    timeCN: function (val) {
      val = val || "";
      let y = val.split("-").shift(),
        m = val.split("-").pop();
      return y + "年 " + m + "月";
    },
  },
  methods: {
    // 折叠商品
    accordionProducts() {
      this.$emit("accordionProducts", !this.isAccordion);
    },
    clearKey(type) {
      switch (type) {
        case "statusId":
          this.$parent.filterProp.status = "";
          this.$parent.activeGroupName = "";
          break;
        case "code":
          this.$parent.filterProp.code = "";
          break;
        case "batchBool":
          this.$parent.getRMOrder(undefined, 'common');
          break;
        case "key_id":
          this.$parent.filterProp.name = "";
          this.$parent.filterProp.id = "";
          break;
        case "time":
          this.$parent.filterProp.timeCreatedFrom = "";
          this.$parent.filterProp.timeCreatedTo = "";
          break;
      }
      this.$parent.toPage(1);
    },
    // 导入采购单
    importOrder() {
      $("#modalImportOrder").modal("show");
    },
    // 导出采购单
    exportOrder() {
      if (this.check_arr.length == 0) return;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierPurchaseOrder.export",
        {
          code: this.check_arr,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            this.$parent.checkArr = [];
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            openDownload(r.Data.Results);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.ordertime-select {
  border: 1px rgba(255, 255, 255, 0.4) solid;
}

.ordertime-select > a {
  color: #fff;
  line-height: 20px;
  padding: 0 0.75rem;
}

.ordertime-select .dropdown-menu {
  min-width: 8.2875rem;
  padding: 0;
  border-radius: 0;
  margin-top: -0.0625rem;
  margin-left: -0.0625rem;
}

.ordertime-select .nav .nav-link {
  width: 100%;
  padding: 0 0.75rem;
}

.select-month {
  position: relative;
  border: 1px rgba(255, 255, 255, 0.4) solid;
}

.select-month > .selected {
  padding: 0 0.275rem;
  color: #17a2b8;
}

.select-month > .select-list {
  display: none;
  position: absolute;
  z-index: 11;
  width: 10rem;
  height: 6.25rem;
  overflow: hidden;
  border: 1px rgba(255, 255, 255, 0.4) solid;
  border-radius: 0;
  float: none;
  padding: 0;
  margin: 3px 0 0 -1px;
  overflow: hidden;
}

.select-month > .select-list.show {
  display: block;
}

.select-month > .select-list > ul {
  display: flex;
  height: 6.25rem;
  background-color: #1a2432;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  flex-direction: column;
  transition: all 0.5s;
  list-style: none;
}

.select-month li {
  width: 5rem;
  padding: 0 0.125rem;
}

.select-month li > a {
  display: block;
  width: 5rem;
  color: #868ba1;
  font-size: 0.75rem;
  height: 1.25rem;
  line-height: 1.25rem;
  padding: 0 0.25rem;
}

.select-month li > a:hover {
  color: #fff;
}

.select-month li.active > a {
  color: #17a2b8;
}

.select-month .left-arr,
.select-month .right-arr {
  display: none;
  position: absolute;
  top: 3.5rem;
  left: -1.25rem;
  z-index: 11;
  height: 2rem;
  line-height: 2rem;
  color: #868ba1;
  font-size: 1.25rem;
}

.select-month .right-arr {
  left: 10.125rem;
}

.select-month .left-arr:hover,
.select-month .right-arr:hover {
  color: #fff;
}

.select-month.show .left-arr,
.select-month.show .right-arr {
  display: block;
}

.nav .nav-link:visited,
.nav .nav-link:active {
  color: #868ba1;
}

.nav .nav-link:hover {
  color: #fff;
}

.show-white-style .ordertime-select > a {
  color: #343a40;
}

.show-white-style .ordertime-select,
.show-white-style .select-month {
  border: 1px rgba(0, 0, 0, 0.3) solid;
  background: #fff;
}

.show-white-style .ordertime-select .dropdown-menu {
  background-color: #fff;
  color: #343a40;
}

.show-white-style .nav .nav-link:hover,
.show-white-style .select-month li > a:hover {
  color: #343a40;
}

.show-white-style .select-month > .select-list > ul {
  background-color: #fff;
}
</style>